import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import ProductCard from "./ProductCard";
import Breadcrumb from "./Breadcrumb";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";

const Products = () => {
  return (
    <>
      <div className="section-background">
        <Header name="Products" />
        <Breadcrumb
          title="Our"
          highlight="Products"
          paths={[
            { name: "Home", link: "/Home" },
            { name: "Products", link: null }
          ]}
        />
        <ProductCard />
        <Footer />
      </div>
      <ToastContainer />
    </>
  );
};

export default Products;
